import { EventType, ElementType, EventAction } from '@cof/stratum';

// PRODUCT_NAME is a required export of this file (use your DevNav component name)
const PRODUCT_NAME = 'fs-vehicle-and-loan-mfe-staticassets';
// PRODUCT_VERSION is a required export of this file
const PRODUCT_VERSION = '2.0.1';
var TagKey;
(function (TagKey) {
    /**
     * Enumerate keys of tag catalog entries here for easy
     * use and consistent reference across your application.
     *
     * The values of the tag keys can be any string or number
     * value. These keys will not be referenced outside
     * of the application.
     */
    TagKey["VEHICLE_LOAN_CONSENT_LOOKUP_CONSENT"] = "VEHICLE_LOAN_CONSENT_LOOKUP_CONSENT";
    TagKey["MANUAL_LOAN_ENTRY_CAPITAL_ONE_LOAN"] = "MANUAL_LOAN_ENTRY_CAPITAL_ONE_LOAN";
    TagKey["MANUAL_LOAN_ENTRY_LEASE"] = "MANUAL_LOAN_ENTRY_LEASE";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_CONSENT"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_CONSENT";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOOKUP"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOOKUP";
    TagKey["VIEW_VEHICLE_VIN_LOOKUP"] = "VIEW_VEHICLE_VIN_LOOKUP";
    TagKey["VEHICLE_VIN_LOOKUP_VIN_HELP_MODULE"] = "VEHICLE_VIN_LOOKUP_VIN_HELP_MODULE";
    TagKey["VEHICLE_VIN_LOOKUP_VIN_SUCCESS_NADA"] = "VEHICLE_VIN_LOOKUP_VIN_SUCCESS_NADA";
    TagKey["VEHICLE_LICENSE_PLATE_LOOKUP_LICENSE_PLATE_SUCCESS_CARFAX"] = "VEHICLE_LICENSE_PLATE_LOOKUP_LICENSE_PLATE_SUCCESS_CARFAX";
    TagKey["VEHICLE_LICENSE_PLATE_LOOKUP_CARFAX_API_DOWN_ERROR"] = "VEHICLE_LICENSE_PLATE_LOOKUP_CARFAX_API_DOWN_ERROR";
    TagKey["VEHICLE_VIN_LOOKUP_NADA_API_DOWN_ERROR"] = "VEHICLE_VIN_LOOKUP_NADA_API_DOWN_ERROR";
    TagKey["VIEW_VEHICLE_VIN_LOOKUP_2"] = "VIEW_VEHICLE_VIN_LOOKUP_2";
    TagKey["VIEW_VEHICLE_LICENSE_PLATE_LOOKUP"] = "VIEW_VEHICLE_LICENSE_PLATE_LOOKUP";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_VEHICLE"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_VEHICLE";
    TagKey["VEHICLE_FOUND_VEHICLE_FOUND_ELIGIBLE"] = "VEHICLE_FOUND_VEHICLE_FOUND_ELIGIBLE";
    TagKey["VEHICLE_FOUND_VEHICLE_FOUND_INELIGIBLE"] = "VEHICLE_FOUND_VEHICLE_FOUND_INELIGIBLE";
    TagKey["VEHICLE_FOUND_CHOOSE_A_DIFFERENT_VEHICLE"] = "VEHICLE_FOUND_CHOOSE_A_DIFFERENT_VEHICLE";
    TagKey["VEHICLE_FOUND_VEHICLE_SELECTED_LN"] = "VEHICLE_FOUND_VEHICLE_SELECTED_LN";
    TagKey["VEHICLE_FOUND_VEHICLE_SELECTED_VIN"] = "VEHICLE_FOUND_VEHICLE_SELECTED_VIN";
    TagKey["VEHICLE_FOUND_VEHICLE_SELECTED_LICENSE_PLATE"] = "VEHICLE_FOUND_VEHICLE_SELECTED_LICENSE_PLATE";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_MANUAL"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_MANUAL";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN";
    TagKey["MANUAL_LOAN_ENTRY_PAYOFF_LOCATION_MODULE"] = "MANUAL_LOAN_ENTRY_PAYOFF_LOCATION_MODULE";
    TagKey["VIEW_COF_LOAN_ERROR_SCREEN"] = "VIEW_COF_LOAN_ERROR_SCREEN";
    TagKey["COF_LOAN_ERROR_SCREEN_CHOOSE_VEHICLE_COF_LOAN_ERROR"] = "COF_LOAN_ERROR_SCREEN_CHOOSE_VEHICLE_COF_LOAN_ERROR";
    TagKey["COF_LOAN_ERROR_SCREEN_ELIGIBILITY_REQUIREMENTS_COF_LOAN_ERROR"] = "COF_LOAN_ERROR_SCREEN_ELIGIBILITY_REQUIREMENTS_COF_LOAN_ERROR";
    TagKey["REFI_LEADS_VEHICLE_LEADS_SAVE"] = "REFI_LEADS_VEHICLE_LEADS_SAVE";
    TagKey["MIN_PAPR_MODULE_PAPR_MODAL_SHOWN"] = "MIN_PAPR_MODULE_PAPR_MODAL_SHOWN";
    TagKey["TU_LOAN_SELECTION_TU_LOAN_SELECTED"] = "TU_LOAN_SELECTION_TU_LOAN_SELECTED";
    TagKey["LOAN_LOOKUP_INELIGIBLE_LOAN"] = "LOAN_LOOKUP_INELIGIBLE_LOAN";
    TagKey["MANUAL_LOAN_ENTRY_MANUAL_LOAN_FIELD_VALIDATION_ERROR"] = "MANUAL_LOAN_ENTRY_MANUAL_LOAN_FIELD_VALIDATION_ERROR";
    TagKey["LOAN_LOOKUP_REASON_FOR_TU_INELIGIBLE_LOAN"] = "LOAN_LOOKUP_REASON_FOR_TU_INELIGIBLE_LOAN";
    TagKey["LOAN_LOOKUP_CALCULATED_BALANCE"] = "LOAN_LOOKUP_CALCULATED_BALANCE";
    TagKey["LOAN_LOOKUP_TU_BALANCE"] = "LOAN_LOOKUP_TU_BALANCE";
    TagKey["LOAN_LOOKUP_CHANGE_VEHICLE_LOAN_LINK"] = "LOAN_LOOKUP_CHANGE_VEHICLE_LOAN_LINK";
    TagKey["VEHICLE_LOAN_VEHICLE_LOAN_COMBINATION_SELECTED"] = "VEHICLE_LOAN_VEHICLE_LOAN_COMBINATION_SELECTED";
    TagKey["VEHICLE_LOAN_VEHICLE_LOAN_MATCH_FOUND"] = "VEHICLE_LOAN_VEHICLE_LOAN_MATCH_FOUND";
    TagKey["VEHICLE_LOAN_VEHICLE_LOAN_MATCH_NOT_FOUND"] = "VEHICLE_LOAN_VEHICLE_LOAN_MATCH_NOT_FOUND";
    TagKey["MANUAL_LOAN_ENTRY_MANUAL_ENTRY_MONTHLY_PMT"] = "MANUAL_LOAN_ENTRY_MANUAL_ENTRY_MONTHLY_PMT";
    TagKey["MANUAL_LOAN_ENTRY_MANUAL_ENTRY_TERM"] = "MANUAL_LOAN_ENTRY_MANUAL_ENTRY_TERM";
    TagKey["MANUAL_LOAN_ENTRY_MANUAL_ENTRY_BALANCE"] = "MANUAL_LOAN_ENTRY_MANUAL_ENTRY_BALANCE";
    TagKey["TU_LOAN_SELECTION_TU_LOAN_FOUND"] = "TU_LOAN_SELECTION_TU_LOAN_FOUND";
    TagKey["VEHICLE_FOUND_LN_VEHICLE_FOUND"] = "VEHICLE_FOUND_LN_VEHICLE_FOUND";
    TagKey["MANUAL_LOAN_ENTRY_MANUAL_ENTRY_SUBMIT"] = "MANUAL_LOAN_ENTRY_MANUAL_ENTRY_SUBMIT";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_VEHICLE_LOAN_MATCH"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_VEHICLE_LOAN_MATCH";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_MANUAL_CONFIRMATION"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_MANUAL_CONFIRMATION";
    TagKey["ICONIC_VEHICLE_AND_LOAN_EDIT_CAR_BUTTON"] = "ICONIC_VEHICLE_AND_LOAN_EDIT_CAR_BUTTON";
    TagKey["ICONIC_VEHICLE_AND_LOAN_CHECK_ELIGIBILITY_CTA"] = "ICONIC_VEHICLE_AND_LOAN_CHECK_ELIGIBILITY_CTA";
    TagKey["CAR_CHECKOUT__TITLE_STIP_MUDFLAP_LOADS"] = "CAR_CHECKOUT__TITLE_STIP_MUDFLAP_LOADS";
    TagKey["CAR_CHECKOUT__VAL_MFE_LOAD"] = "CAR_CHECKOUT__VAL_MFE_LOAD";
    TagKey["ICONIC_VEHICLE_AND_LOAN_GO_BACK_TO_LOAN_OPTIONS"] = "ICONIC_VEHICLE_AND_LOAN_GO_BACK_TO_LOAN_OPTIONS";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_EXIT"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_EXIT";
    TagKey["VEHICLE_LOAN_CONSENT_LOOKUP_CONSENT_2"] = "VEHICLE_LOAN_CONSENT_LOOKUP_CONSENT_2";
    TagKey["MANUAL_LOAN_ENTRY_CAPITAL_ONE_LOAN_2"] = "MANUAL_LOAN_ENTRY_CAPITAL_ONE_LOAN_2";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_2"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_2";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_CONSENT_2"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_CONSENT_2";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOOKUP_2"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOOKUP_2";
    TagKey["VIEW_VEHICLE_VIN_LOOKUP_3"] = "VIEW_VEHICLE_VIN_LOOKUP_3";
    TagKey["VEHICLE_VIN_LOOKUP_VIN_HELP_MODULE_2"] = "VEHICLE_VIN_LOOKUP_VIN_HELP_MODULE_2";
    TagKey["VEHICLE_VIN_LOOKUP_NADA_VIN_LOOKUP_SUCCESS"] = "VEHICLE_VIN_LOOKUP_NADA_VIN_LOOKUP_SUCCESS";
    TagKey["VEHICLE_LICENSE_PLATE_LOOKUP_CARFAX_LICENSE_PLATE_LOOKUP_SUCCESS"] = "VEHICLE_LICENSE_PLATE_LOOKUP_CARFAX_LICENSE_PLATE_LOOKUP_SUCCESS";
    TagKey["VEHICLE_LICENSE_PLATE_LOOKUP_CARFAX_LICENSE_PLATE_LOOKUP_ERROR"] = "VEHICLE_LICENSE_PLATE_LOOKUP_CARFAX_LICENSE_PLATE_LOOKUP_ERROR";
    TagKey["VEHICLE_VIN_LOOKUP_NADA_VIN_LOOKUP_ERROR"] = "VEHICLE_VIN_LOOKUP_NADA_VIN_LOOKUP_ERROR";
    TagKey["VIEW_VEHICLE_VIN_LOOKUP_4"] = "VIEW_VEHICLE_VIN_LOOKUP_4";
    TagKey["VIEW_VEHICLE_LICENSE_PLATE_LOOKUP_2"] = "VIEW_VEHICLE_LICENSE_PLATE_LOOKUP_2";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_VEHICLE_2"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_VEHICLE_2";
    TagKey["VEHICLE_FOUND_VEHICLE_FOUND_ELIGIBLE_2"] = "VEHICLE_FOUND_VEHICLE_FOUND_ELIGIBLE_2";
    TagKey["VEHICLE_FOUND_VEHICLE_FOUND_INELIGIBLE_2"] = "VEHICLE_FOUND_VEHICLE_FOUND_INELIGIBLE_2";
    TagKey["VEHICLE_FOUND_CHOOSE_A_DIFFERENT_VEHICLE_2"] = "VEHICLE_FOUND_CHOOSE_A_DIFFERENT_VEHICLE_2";
    TagKey["VEHICLE_FOUND_VEHICLE_SELECTED_SSN"] = "VEHICLE_FOUND_VEHICLE_SELECTED_SSN";
    TagKey["VEHICLE_FOUND_VEHICLE_SELECTED_VIN_2"] = "VEHICLE_FOUND_VEHICLE_SELECTED_VIN_2";
    TagKey["VEHICLE_FOUND_VEHICLE_SELECTED_LICENSE_PLATE_2"] = "VEHICLE_FOUND_VEHICLE_SELECTED_LICENSE_PLATE_2";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_MANUAL_2"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_MANUAL_2";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_2"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_2";
    TagKey["MANUAL_LOAN_ENTRY_PAYOFF_LOCATION_MODULE_2"] = "MANUAL_LOAN_ENTRY_PAYOFF_LOCATION_MODULE_2";
    TagKey["VIEW_COF_LOAN_ERROR_SCREEN_2"] = "VIEW_COF_LOAN_ERROR_SCREEN_2";
    TagKey["COF_LOAN_ERROR_SCREEN_CHOOSE_VEHICLE_COF_LOAN_ERROR_2"] = "COF_LOAN_ERROR_SCREEN_CHOOSE_VEHICLE_COF_LOAN_ERROR_2";
    TagKey["COF_LOAN_ERROR_SCREEN_ELIGIBILITY_REQUIREMENTS_COF_LOAN_ERROR_2"] = "COF_LOAN_ERROR_SCREEN_ELIGIBILITY_REQUIREMENTS_COF_LOAN_ERROR_2";
    TagKey["REFI_LEADS_VEHICLE_LEADS_SAVE_2"] = "REFI_LEADS_VEHICLE_LEADS_SAVE_2";
    TagKey["MIN_PAPR_MODULE_PAPR_MODAL_SHOWN_2"] = "MIN_PAPR_MODULE_PAPR_MODAL_SHOWN_2";
    TagKey["TU_LOAN_SELECTION_TU_LOAN_SELECTED_2"] = "TU_LOAN_SELECTION_TU_LOAN_SELECTED_2";
    TagKey["LOAN_LOOKUP_LOAN_FOUND_INELIGIBLE"] = "LOAN_LOOKUP_LOAN_FOUND_INELIGIBLE";
    TagKey["LOAN_LOOKUP_INELIGIBLE_VEHICLE_LOAN_REASON"] = "LOAN_LOOKUP_INELIGIBLE_VEHICLE_LOAN_REASON";
    TagKey["LOAN_LOOKUP_CALCULATED_BALANCE_2"] = "LOAN_LOOKUP_CALCULATED_BALANCE_2";
    TagKey["LOAN_LOOKUP_TU_BALANCE_2"] = "LOAN_LOOKUP_TU_BALANCE_2";
    TagKey["LOAN_LOOKUP_CHANGE_VEHICLE_LOAN_LINK_2"] = "LOAN_LOOKUP_CHANGE_VEHICLE_LOAN_LINK_2";
    TagKey["VEHICLE_LOAN_VEHICLE_LOAN_COMBINATION_SELECTED_2"] = "VEHICLE_LOAN_VEHICLE_LOAN_COMBINATION_SELECTED_2";
    TagKey["VEHICLE_LOAN_VEHICLE_LOAN_MATCH_FOUND_2"] = "VEHICLE_LOAN_VEHICLE_LOAN_MATCH_FOUND_2";
    TagKey["VEHICLE_LOAN_VEHICLE_LOAN_MATCH_NOT_FOUND_2"] = "VEHICLE_LOAN_VEHICLE_LOAN_MATCH_NOT_FOUND_2";
    TagKey["TU_LOAN_SELECTION_TU_LOAN_FOUND_2"] = "TU_LOAN_SELECTION_TU_LOAN_FOUND_2";
    TagKey["VEHICLE_FOUND_LN_VEHICLE_FOUND_2"] = "VEHICLE_FOUND_LN_VEHICLE_FOUND_2";
    TagKey["MANUAL_LOAN_ENTRY_MANUAL_ENTRY_SUBMIT_2"] = "MANUAL_LOAN_ENTRY_MANUAL_ENTRY_SUBMIT_2";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_VEHICLE_LOAN_MATCH_2"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_VEHICLE_LOAN_MATCH_2";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_MANUAL_CONFIRMATION_2"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_MANUAL_CONFIRMATION_2";
    TagKey["ICONIC_VEHICLE_AND_LOAN_EDIT_VEHICLE_LINK"] = "ICONIC_VEHICLE_AND_LOAN_EDIT_VEHICLE_LINK";
    TagKey["ICONIC_VEHICLE_AND_LOAN_CHECK_ELIGIBILITY_CTA_2"] = "ICONIC_VEHICLE_AND_LOAN_CHECK_ELIGIBILITY_CTA_2";
    TagKey["CAR_CHECKOUT__TITLE_STIP_MUDFLAP_LOADS_2"] = "CAR_CHECKOUT__TITLE_STIP_MUDFLAP_LOADS_2";
    TagKey["CAR_CHECKOUT__VAL_MFE_LOAD_2"] = "CAR_CHECKOUT__VAL_MFE_LOAD_2";
    TagKey["ICONIC_VEHICLE_AND_LOAN_GO_BACK_TO_LOAN_OPTIONS_2"] = "ICONIC_VEHICLE_AND_LOAN_GO_BACK_TO_LOAN_OPTIONS_2";
    TagKey["PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_EXIT_2"] = "PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_EXIT_2";
    TagKey["ICONIC_VEHICLE_AND_LOAN_CREDIT_DISPUTE_LINK"] = "ICONIC_VEHICLE_AND_LOAN_CREDIT_DISPUTE_LINK";
    TagKey["ICONIC_VEHICLE_AND_LOAN_VEHICLE_SHOWN"] = "ICONIC_VEHICLE_AND_LOAN_VEHICLE_SHOWN";
    TagKey["ICONIC_VEHICLE_AND_LOAN_LOAN_SHOWN"] = "ICONIC_VEHICLE_AND_LOAN_LOAN_SHOWN";
    TagKey["ICONIC_VEHICLE_AND_LOAN_RETURN_TO_CAPITAL_ONE_BUTTON"] = "ICONIC_VEHICLE_AND_LOAN_RETURN_TO_CAPITAL_ONE_BUTTON";
    TagKey["ICONIC_VEHICLE_AND_LOAN_CALCULATED_LTV"] = "ICONIC_VEHICLE_AND_LOAN_CALCULATED_LTV";
    TagKey["ICONIC_VEHICLE_AND_LOAN_CHANGE_LOAN_LINK"] = "ICONIC_VEHICLE_AND_LOAN_CHANGE_LOAN_LINK";
    TagKey["ICONIC_VEHICLE_AND_LOAN_ELIGIBILITY_REQUIREMENTS_LINK"] = "ICONIC_VEHICLE_AND_LOAN_ELIGIBILITY_REQUIREMENTS_LINK";
    TagKey["ICONIC_VEHICLE_AND_LOAN_EDITED_FIELD"] = "ICONIC_VEHICLE_AND_LOAN_EDITED_FIELD";
    TagKey["LOAN_LOOKUP_LOAN_FOUND_ELIGIBLE"] = "LOAN_LOOKUP_LOAN_FOUND_ELIGIBLE";
    TagKey["VEHICLE_LOAN_MATCH_VEHICLE_LOAN_MATCH_FLAG"] = "VEHICLE_LOAN_MATCH_VEHICLE_LOAN_MATCH_FLAG";
})(TagKey || (TagKey = {}));
// TAG_CATALOG is a required export of this file
const TAG_CATALOG = {
    /**
     * Add TagCatalog entries here. Best practice
     * is to use enumerated values for the tag keys.
     *
     * For properties with values of a specific type (like eventType),
     * export the corresponding type from the @cof/stratum package.
     */
    [TagKey.VEHICLE_LOAN_CONSENT_LOOKUP_CONSENT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks checkbox for consent to Vehicle and Loan Lookup',
        tagId: 3001,
        featureName: 'Vehicle-Loan Consent',
        tagName: 'lookup consent',
        elementType: ElementType.CHECKBOX,
        action: EventAction.CHECK,
    },
    [TagKey.MANUAL_LOAN_ENTRY_CAPITAL_ONE_LOAN]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks radio button options for Is this a Capital One loan',
        tagId: 3002,
        featureName: 'Manual Loan Entry',
        tagName: 'capital one loan',
        elementType: ElementType.RADIO,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Vehicle-Loan MFE Loads',
        tagId: 3003,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'vehicle-loan',
            level5: '',
            country: 'USA',
            language: 'English',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_CONSENT]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Vehicle-Loan Consent step shown',
        tagId: 3004,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'vehicle-loan',
            level5: 'consent',
            country: 'USA',
            language: 'English',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOOKUP]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Vehicle Lookup step shown',
        tagId: 3005,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'vehicle-loan',
            level5: 'lookup',
            country: 'USA',
            language: 'English',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.VIEW_VEHICLE_VIN_LOOKUP]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'User clicks Vehicle VIN Lookup step shown',
        tagId: 3006,
        featureName: 'Vehicle VIN lookup',
    },
    [TagKey.VEHICLE_VIN_LOOKUP_VIN_HELP_MODULE]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks link to module "Need help finding your VIN?"',
        tagId: 3007,
        featureName: 'Vehicle VIN lookup',
        tagName: 'vin help module',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.VEHICLE_VIN_LOOKUP_VIN_SUCCESS_NADA]: {
        eventType: EventType.UI,
        tagDescription: 'NADA VIN lookup successfully finds user vehicle',
        tagId: 3008,
        featureName: 'Vehicle VIN lookup',
        tagName: 'vin success nada',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.VEHICLE_LICENSE_PLATE_LOOKUP_LICENSE_PLATE_SUCCESS_CARFAX]: {
        eventType: EventType.UI,
        tagDescription: 'CarFax License plate lookup successfully finds user vehicle',
        tagId: 3009,
        featureName: 'Vehicle License Plate lookup',
        tagName: 'license plate success carfax',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.VEHICLE_LICENSE_PLATE_LOOKUP_CARFAX_API_DOWN_ERROR]: {
        eventType: EventType.UI,
        tagDescription: 'CarFax License plate lookup service error ',
        tagId: 3010,
        featureName: 'Vehicle License Plate lookup',
        tagName: 'carfax api down error',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.VEHICLE_VIN_LOOKUP_NADA_API_DOWN_ERROR]: {
        eventType: EventType.UI,
        tagDescription: 'NADA VIN lookup service error ',
        tagId: 3011,
        featureName: 'Vehicle VIN lookup',
        tagName: 'nada api down error',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.VIEW_VEHICLE_VIN_LOOKUP_2]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Vehicle VIN Lookup Unable to Find ',
        tagId: 3012,
        featureName: 'Vehicle VIN lookup',
    },
    [TagKey.VIEW_VEHICLE_LICENSE_PLATE_LOOKUP]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Vehicle License Plate Lookup Unable to Find ',
        tagId: 3013,
        featureName: 'Vehicle License Plate lookup',
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_VEHICLE]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Vehicle Found step shown',
        tagId: 3014,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'vehicle-loan',
            level5: 'vehicle',
            country: 'USA',
            language: 'English',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.VEHICLE_FOUND_VEHICLE_FOUND_ELIGIBLE]: {
        eventType: EventType.UI,
        tagDescription: 'An eligible Vehicle is found and we display Year Make and Model',
        tagId: 3015,
        featureName: 'Vehicle Found',
        tagName: 'vehicle found eligible',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.VEHICLE_FOUND_VEHICLE_FOUND_INELIGIBLE]: {
        eventType: EventType.UI,
        tagDescription: 'A ineligible vehicle is found and we display Year Make and Model ',
        tagId: 3016,
        featureName: 'Vehicle Found',
        tagName: 'vehicle found ineligible',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.VEHICLE_FOUND_CHOOSE_A_DIFFERENT_VEHICLE]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Choose a different vehicle"',
        tagId: 3017,
        featureName: 'Vehicle Found',
        tagName: 'choose a different vehicle',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.VEHICLE_FOUND_VEHICLE_SELECTED_LN]: {
        eventType: EventType.UI,
        tagDescription: 'User selects from list of found vehicles using LN',
        tagId: 3018,
        featureName: 'Vehicle Found',
        tagName: 'vehicle selected ln',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.VEHICLE_FOUND_VEHICLE_SELECTED_VIN]: {
        eventType: EventType.UI,
        tagDescription: 'User selects from list of found vehicles using VIN lookup',
        tagId: 3019,
        featureName: 'Vehicle Found',
        tagName: 'vehicle selected vin',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.VEHICLE_FOUND_VEHICLE_SELECTED_LICENSE_PLATE]: {
        eventType: EventType.UI,
        tagDescription: 'User selects from list of found vehicles using License Plate lookup',
        tagId: 3020,
        featureName: 'Vehicle Found',
        tagName: 'vehicle selected license plate',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_MANUAL]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Manual Loan entry step shown',
        tagId: 3021,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'vehicle-loan',
            level5: 'loan|manual',
            country: 'USA',
            language: 'English',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'TU Loan selection step shown',
        tagId: 3022,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'vehicle-loan',
            level5: 'loan',
            country: 'USA',
            language: 'English',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.MANUAL_LOAN_ENTRY_PAYOFF_LOCATION_MODULE]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks link to "What is a payoff amount?" module',
        tagId: 3023,
        featureName: 'Manual Loan Entry',
        tagName: 'payoff location module',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.VIEW_COF_LOAN_ERROR_SCREEN]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'User sees "We only refinance cars that aren\'t currently financed by Capital One"',
        tagId: 3024,
        featureName: 'COF Loan Error Screen',
    },
    [TagKey.COF_LOAN_ERROR_SCREEN_CHOOSE_VEHICLE_COF_LOAN_ERROR]: {
        eventType: EventType.UI,
        tagDescription: 'User selects button to Choose a different vehicle ',
        tagId: 3025,
        featureName: 'COF Loan Error Screen',
        tagName: 'choose vehicle cof loan error',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.COF_LOAN_ERROR_SCREEN_ELIGIBILITY_REQUIREMENTS_COF_LOAN_ERROR]: {
        eventType: EventType.UI,
        tagDescription: 'User selects link to see eligibility requirements',
        tagId: 3026,
        featureName: 'COF Loan Error Screen',
        tagName: 'eligibility requirements cof loan error',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.REFI_LEADS_VEHICLE_LEADS_SAVE]: {
        eventType: EventType.UI,
        tagDescription: 'System saves vehicle data to the Refi Leads DB',
        tagId: 3027,
        featureName: 'Refi Leads',
        tagName: 'vehicle leads save',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.MIN_PAPR_MODULE_PAPR_MODAL_SHOWN]: {
        eventType: EventType.UI,
        tagDescription: 'System displays papr modal for apr ${apr} < minimum ${minApr}',
        tagId: 3028,
        featureName: 'Min PAPR Module',
        tagName: 'papr modal shown',
        elementType: ElementType.MODAL,
        action: EventAction.LOAD,
    },
    [TagKey.TU_LOAN_SELECTION_TU_LOAN_SELECTED]: {
        eventType: EventType.UI,
        tagDescription: 'User selects an eligible TU pre-fill loan',
        tagId: 3029,
        featureName: 'TU Loan Selection',
        tagName: 'tu loan selected',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.LOAN_LOOKUP_INELIGIBLE_LOAN]: {
        eventType: EventType.UI,
        tagDescription: 'System finds an ineligible TU loan following loan lookup',
        tagId: 3030,
        featureName: 'Loan Lookup',
        tagName: 'ineligible loan',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.MANUAL_LOAN_ENTRY_MANUAL_LOAN_FIELD_VALIDATION_ERROR]: {
        eventType: EventType.UI,
        tagDescription: 'User enters a value into a manual loan field that results in a field validation error',
        tagId: 3031,
        featureName: 'Manual Loan Entry',
        tagName: 'manual loan field validation error',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}',
    },
    [TagKey.LOAN_LOOKUP_REASON_FOR_TU_INELIGIBLE_LOAN]: {
        eventType: EventType.UI,
        tagDescription: 'A TU Loan is ineligible and we display the reason for in-app decline',
        tagId: 3032,
        featureName: 'Loan Lookup',
        tagName: 'reason for tu ineligible loan',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.LOAN_LOOKUP_CALCULATED_BALANCE]: {
        eventType: EventType.UI,
        tagDescription: 'System uses calculated balance amount for Vehicle balance',
        tagId: 3033,
        featureName: 'Loan lookup',
        tagName: 'calculated balance',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.LOAN_LOOKUP_TU_BALANCE]: {
        eventType: EventType.UI,
        tagDescription: 'System uses TU prefilled amount for Vehicle balance',
        tagId: 3034,
        featureName: 'Loan Lookup',
        tagName: 'tu balance',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.LOAN_LOOKUP_CHANGE_VEHICLE_LOAN_LINK]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks change vehicle or loan selected link',
        tagId: 3035,
        featureName: 'Loan Lookup',
        tagName: 'change vehicle-loan link',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.VEHICLE_LOAN_VEHICLE_LOAN_COMBINATION_SELECTED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks an eligible Vehicle-Loan Match',
        tagId: 3036,
        featureName: 'Vehicle-Loan',
        tagName: 'vehicle-loan combination selected',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.VEHICLE_LOAN_VEHICLE_LOAN_MATCH_FOUND]: {
        eventType: EventType.UI,
        tagDescription: 'System matches a LN vehicle and TU loan through lienholder matching',
        tagId: 3037,
        featureName: 'Vehicle-Loan',
        tagName: 'vehicle-loan match found',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.VEHICLE_LOAN_VEHICLE_LOAN_MATCH_NOT_FOUND]: {
        eventType: EventType.UI,
        tagDescription: 'System cannot match a LN vehicle and TU loan through lienholder matching',
        tagId: 3038,
        featureName: 'Vehicle-Loan',
        tagName: 'vehicle-loan match not found',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.MANUAL_LOAN_ENTRY_MANUAL_ENTRY_MONTHLY_PMT]: {
        eventType: EventType.UI,
        tagDescription: 'User enters the Manual Loan Entry field for Monthly PMT',
        tagId: 3039,
        featureName: 'Manual Loan Entry',
        tagName: 'manual entry monthly pmt',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}',
    },
    [TagKey.MANUAL_LOAN_ENTRY_MANUAL_ENTRY_TERM]: {
        eventType: EventType.UI,
        tagDescription: 'User enters the Manual Loan Entry field for term',
        tagId: 3040,
        featureName: 'Manual Loan Entry',
        tagName: 'manual entry term',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}',
    },
    [TagKey.MANUAL_LOAN_ENTRY_MANUAL_ENTRY_BALANCE]: {
        eventType: EventType.UI,
        tagDescription: 'User enters the Manual Loan Entry field for principal balance',
        tagId: 3041,
        featureName: 'Manual Loan Entry',
        tagName: 'manual entry balance',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}',
    },
    [TagKey.TU_LOAN_SELECTION_TU_LOAN_FOUND]: {
        eventType: EventType.UI,
        tagDescription: 'System finds loans for this customer using Transunion',
        tagId: 3042,
        featureName: 'TU Loan Selection',
        tagName: 'tu loan found',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.VEHICLE_FOUND_LN_VEHICLE_FOUND]: {
        eventType: EventType.UI,
        tagDescription: 'System finds vehicles for this customer using Lexis Nexis',
        tagId: 3043,
        featureName: 'Vehicle Found',
        tagName: 'ln vehicle found',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.MANUAL_LOAN_ENTRY_MANUAL_ENTRY_SUBMIT]: {
        eventType: EventType.UI,
        tagDescription: 'User submits Manual Loan Entry',
        tagId: 3044,
        featureName: 'Manual Loan Entry',
        tagName: 'manual entry submit',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_VEHICLE_LOAN_MATCH]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Vehicle-Loan Match Page',
        tagId: 3045,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'vehicle-loan',
            level5: 'vehicle-loan-match',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_MANUAL_CONFIRMATION]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Vehicle-Loan Confirmation Page',
        tagId: 3046,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'vehicle-loan',
            level5: 'loan|manual|confirmation',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.ICONIC_VEHICLE_AND_LOAN_EDIT_CAR_BUTTON]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks edit car button',
        tagId: 3047,
        featureName: 'Iconic Vehicle and Loan',
        tagName: 'edit car button',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.ICONIC_VEHICLE_AND_LOAN_CHECK_ELIGIBILITY_CTA]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Check eligibility" link',
        tagId: 3048,
        featureName: 'Iconic Vehicle and Loan',
        tagName: 'check eligibility cta',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.CAR_CHECKOUT__TITLE_STIP_MUDFLAP_LOADS]: {
        eventType: EventType.UI,
        tagDescription: 'Title Stip mudflap loads successfully',
        tagId: 3049,
        featureName: 'Car Checkout ',
        tagName: 'title stip mudflap loads',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.CAR_CHECKOUT__VAL_MFE_LOAD]: {
        eventType: EventType.UI,
        tagDescription: 'Checkout Page loads VAL mfe',
        tagId: 3050,
        featureName: 'Car Checkout ',
        tagName: 'val mfe load',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.ICONIC_VEHICLE_AND_LOAN_GO_BACK_TO_LOAN_OPTIONS]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Go back to loan options" from manual loan entry page',
        tagId: 3051,
        featureName: 'Iconic Vehicle and Loan',
        tagName: 'go back to loan options',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_EXIT]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Vehicle-Loan Graceful Exit Page',
        tagId: 3052,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'vehicle-loan',
            level5: 'exit',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.VEHICLE_LOAN_MATCH_VEHICLE_LOAN_MATCH_FLAG]: {
        eventType: EventType.UI,
        tagDescription: 'System identifies whether a Vehicle-Loan Match was selected',
        tagId: 3053,
        featureName: 'Vehicle-loan match',
        tagName: 'Vehicle-loan match flag',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.VEHICLE_LOAN_CONSENT_LOOKUP_CONSENT_2]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks checkbox for consent to Vehicle and Loan Lookup',
        tagId: 3501,
        featureName: 'Vehicle-Loan Consent',
        tagName: 'lookup consent',
        elementType: ElementType.CHECKBOX,
        action: EventAction.CHECK,
    },
    [TagKey.MANUAL_LOAN_ENTRY_CAPITAL_ONE_LOAN_2]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks radio button options for Is this a Capital One loan',
        tagId: 3502,
        featureName: 'Manual Loan Entry',
        tagName: 'capital one loan',
        elementType: ElementType.RADIO,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_2]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Vehicle-Loan Flow',
        tagId: 3503,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'vehicle-loan',
            level5: '',
            country: 'USA',
            language: 'English',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_CONSENT_2]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Vehicle-Loan Consent step shown',
        tagId: 3504,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'vehicle-loan',
            level5: 'consent',
            country: 'USA',
            language: 'English',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOOKUP_2]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Vehicle Lookup step shown',
        tagId: 3505,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'vehicle-loan',
            level5: 'lookup',
            country: 'USA',
            language: 'English',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.VIEW_VEHICLE_VIN_LOOKUP_3]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'User clicks Vehicle VIN Lookup step shown',
        tagId: 3506,
        featureName: 'Vehicle VIN lookup',
    },
    [TagKey.VEHICLE_VIN_LOOKUP_VIN_HELP_MODULE_2]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks link to module "Need help finding your VIN?"',
        tagId: 3507,
        featureName: 'Vehicle VIN lookup',
        tagName: 'vin help module',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.VEHICLE_VIN_LOOKUP_NADA_VIN_LOOKUP_SUCCESS]: {
        eventType: EventType.UI,
        tagDescription: 'NADA VIN lookup successfully finds user vehicle',
        tagId: 3508,
        featureName: 'Vehicle VIN lookup',
        tagName: 'nada vin lookup success',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.VEHICLE_LICENSE_PLATE_LOOKUP_CARFAX_LICENSE_PLATE_LOOKUP_SUCCESS]: {
        eventType: EventType.UI,
        tagDescription: 'CarFax License plate lookup successfully finds user vehicle',
        tagId: 3509,
        featureName: 'Vehicle License Plate lookup',
        tagName: 'carfax license plate lookup success',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.VEHICLE_LICENSE_PLATE_LOOKUP_CARFAX_LICENSE_PLATE_LOOKUP_ERROR]: {
        eventType: EventType.UI,
        tagDescription: 'CarFax License plate lookup service error ',
        tagId: 3510,
        featureName: 'Vehicle License Plate lookup',
        tagName: 'carfax license plate lookup error',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.VEHICLE_VIN_LOOKUP_NADA_VIN_LOOKUP_ERROR]: {
        eventType: EventType.UI,
        tagDescription: 'NADA VIN lookup service error ',
        tagId: 3511,
        featureName: 'Vehicle VIN lookup',
        tagName: 'nada vin lookup error',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.VIEW_VEHICLE_VIN_LOOKUP_4]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Vehicle VIN Lookup Unable to Find ',
        tagId: 3512,
        featureName: 'Vehicle VIN lookup',
    },
    [TagKey.VIEW_VEHICLE_LICENSE_PLATE_LOOKUP_2]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Vehicle License Plate Lookup Unable to Find ',
        tagId: 3513,
        featureName: 'Vehicle License Plate lookup',
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_VEHICLE_2]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Vehicle Found step shown',
        tagId: 3514,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'vehicle-loan',
            level5: 'vehicle',
            country: 'USA',
            language: 'English',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.VEHICLE_FOUND_VEHICLE_FOUND_ELIGIBLE_2]: {
        eventType: EventType.UI,
        tagDescription: 'An eligible Vehicle is found and we display Year Make and Model',
        tagId: 3515,
        featureName: 'Vehicle Found',
        tagName: 'vehicle found eligible',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.VEHICLE_FOUND_VEHICLE_FOUND_INELIGIBLE_2]: {
        eventType: EventType.UI,
        tagDescription: 'A ineligible vehicle is found and we display Year Make and Model ',
        tagId: 3516,
        featureName: 'Vehicle Found',
        tagName: 'vehicle found ineligible',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.VEHICLE_FOUND_CHOOSE_A_DIFFERENT_VEHICLE_2]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Choose a different vehicle"',
        tagId: 3517,
        featureName: 'Vehicle Found',
        tagName: 'choose a different vehicle',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.VEHICLE_FOUND_VEHICLE_SELECTED_SSN]: {
        eventType: EventType.UI,
        tagDescription: 'User selects from list of found vehicles using LN',
        tagId: 3518,
        featureName: 'Vehicle Found',
        tagName: 'vehicle selected ssn',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.VEHICLE_FOUND_VEHICLE_SELECTED_VIN_2]: {
        eventType: EventType.UI,
        tagDescription: 'User selects from list of found vehicles using VIN lookup',
        tagId: 3519,
        featureName: 'Vehicle Found',
        tagName: 'vehicle selected vin',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.VEHICLE_FOUND_VEHICLE_SELECTED_LICENSE_PLATE_2]: {
        eventType: EventType.UI,
        tagDescription: 'User selects from list of found vehicles using License Plate lookup',
        tagId: 3520,
        featureName: 'Vehicle Found',
        tagName: 'vehicle selected license plate',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_MANUAL_2]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Manual Loan entry step shown',
        tagId: 3521,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'vehicle-loan',
            level5: 'loan|manual',
            country: 'USA',
            language: 'English',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_2]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'TU Loan selection step shown',
        tagId: 3522,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'vehicle-loan',
            level5: 'loan',
            country: 'USA',
            language: 'English',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.MANUAL_LOAN_ENTRY_PAYOFF_LOCATION_MODULE_2]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks link to "What is a payoff amount?" module',
        tagId: 3523,
        featureName: 'Manual Loan Entry',
        tagName: 'payoff location module',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.VIEW_COF_LOAN_ERROR_SCREEN_2]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'User sees "We only refinance cars that aren\'t currently financed by Capital One"',
        tagId: 3524,
        featureName: 'COF Loan Error Screen',
    },
    [TagKey.COF_LOAN_ERROR_SCREEN_CHOOSE_VEHICLE_COF_LOAN_ERROR_2]: {
        eventType: EventType.UI,
        tagDescription: 'User selects button to Choose a different vehicle ',
        tagId: 3525,
        featureName: 'COF Loan Error Screen',
        tagName: 'choose vehicle cof loan error',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.COF_LOAN_ERROR_SCREEN_ELIGIBILITY_REQUIREMENTS_COF_LOAN_ERROR_2]: {
        eventType: EventType.UI,
        tagDescription: 'User selects link to see eligibility requirements',
        tagId: 3526,
        featureName: 'COF Loan Error Screen',
        tagName: 'eligibility requirements cof loan error',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.REFI_LEADS_VEHICLE_LEADS_SAVE_2]: {
        eventType: EventType.UI,
        tagDescription: 'System saves vehicle data to the Refi Leads DB',
        tagId: 3527,
        featureName: 'Refi Leads',
        tagName: 'vehicle leads save',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.MIN_PAPR_MODULE_PAPR_MODAL_SHOWN_2]: {
        eventType: EventType.UI,
        tagDescription: 'System displays papr modal for apr ${apr} < minimum ${minApr}',
        tagId: 3528,
        featureName: 'Min PAPR Module',
        tagName: 'papr modal shown',
        elementType: ElementType.MODAL,
        action: EventAction.LOAD,
    },
    [TagKey.TU_LOAN_SELECTION_TU_LOAN_SELECTED_2]: {
        eventType: EventType.UI,
        tagDescription: 'User selects a Transunion pre-filled loan',
        tagId: 3529,
        featureName: 'TU Loan Selection',
        tagName: 'tu loan selected',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.LOAN_LOOKUP_LOAN_FOUND_INELIGIBLE]: {
        eventType: EventType.UI,
        tagDescription: 'System finds an ineligible TU loan following loan lookup',
        tagId: 3530,
        featureName: 'Loan Lookup',
        tagName: 'loan found ineligible',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.LOAN_LOOKUP_INELIGIBLE_VEHICLE_LOAN_REASON]: {
        eventType: EventType.UI,
        tagDescription: 'An ineligible vehicle-loan is selected and we display the reason ',
        tagId: 3532,
        featureName: 'Loan Lookup',
        tagName: 'ineligible vehicle-loan reason',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.LOAN_LOOKUP_CALCULATED_BALANCE_2]: {
        eventType: EventType.UI,
        tagDescription: 'System uses calculated balance amount for Vehicle balance',
        tagId: 3533,
        featureName: 'Loan lookup',
        tagName: 'calculated balance',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.LOAN_LOOKUP_TU_BALANCE_2]: {
        eventType: EventType.UI,
        tagDescription: 'System uses TU prefilled amount for Vehicle balance',
        tagId: 3534,
        featureName: 'Loan Lookup',
        tagName: 'tu balance',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.LOAN_LOOKUP_CHANGE_VEHICLE_LOAN_LINK_2]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks change vehicle or loan selected link',
        tagId: 3535,
        featureName: 'Loan Lookup',
        tagName: 'change vehicle-loan link',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.VEHICLE_LOAN_VEHICLE_LOAN_COMBINATION_SELECTED_2]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks an eligible Vehicle-Loan Match',
        tagId: 3536,
        featureName: 'Vehicle-Loan',
        tagName: 'vehicle-loan combination selected',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.VEHICLE_LOAN_VEHICLE_LOAN_MATCH_FOUND_2]: {
        eventType: EventType.UI,
        tagDescription: 'System matches a LN vehicle and TU loan through lienholder matching',
        tagId: 3537,
        featureName: 'Vehicle-Loan',
        tagName: 'vehicle-loan match found',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.VEHICLE_LOAN_VEHICLE_LOAN_MATCH_NOT_FOUND_2]: {
        eventType: EventType.UI,
        tagDescription: 'System cannot match a LN vehicle and TU loan through lienholder matching',
        tagId: 3538,
        featureName: 'Vehicle-Loan',
        tagName: 'vehicle-loan match not found',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.TU_LOAN_SELECTION_TU_LOAN_FOUND_2]: {
        eventType: EventType.UI,
        tagDescription: 'System finds loans for this customer using Transunion',
        tagId: 3542,
        featureName: 'TU Loan Selection',
        tagName: 'tu loan found',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.VEHICLE_FOUND_LN_VEHICLE_FOUND_2]: {
        eventType: EventType.UI,
        tagDescription: 'System finds vehicles for this customer using Lexis Nexis',
        tagId: 3543,
        featureName: 'Vehicle Found',
        tagName: 'ln vehicle found',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.MANUAL_LOAN_ENTRY_MANUAL_ENTRY_SUBMIT_2]: {
        eventType: EventType.UI,
        tagDescription: 'User submits Manual Loan Entry',
        tagId: 3544,
        featureName: 'Manual Loan Entry',
        tagName: 'manual entry submit',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_VEHICLE_LOAN_MATCH_2]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Vehicle-Loan Match Page',
        tagId: 3545,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'vehicle-loan',
            level5: 'vehicle-loan-match',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_LOAN_MANUAL_CONFIRMATION_2]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Vehicle-Loan Confirmation Page',
        tagId: 3546,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'vehicle-loan',
            level5: 'loan|manual|confirmation',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.ICONIC_VEHICLE_AND_LOAN_EDIT_VEHICLE_LINK]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "edit" vehicle link',
        tagId: 3547,
        featureName: 'Iconic Vehicle and Loan',
        tagName: 'edit vehicle link',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.ICONIC_VEHICLE_AND_LOAN_CHECK_ELIGIBILITY_CTA_2]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Check eligibility" link',
        tagId: 3548,
        featureName: 'Iconic Vehicle and Loan',
        tagName: 'check eligibility cta',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.CAR_CHECKOUT__TITLE_STIP_MUDFLAP_LOADS_2]: {
        eventType: EventType.UI,
        tagDescription: 'Title Stip mudflap loads successfully',
        tagId: 3549,
        featureName: 'Car Checkout ',
        tagName: 'title stip mudflap loads',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.CAR_CHECKOUT__VAL_MFE_LOAD_2]: {
        eventType: EventType.UI,
        tagDescription: 'Checkout Page loads VAL mfe',
        tagId: 3550,
        featureName: 'Car Checkout ',
        tagName: 'val mfe load',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.ICONIC_VEHICLE_AND_LOAN_GO_BACK_TO_LOAN_OPTIONS_2]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Go back to loan options" from manual loan entry page',
        tagId: 3551,
        featureName: 'Iconic Vehicle and Loan',
        tagName: 'go back to loan options',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_VEHICLE_LOAN_EXIT_2]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Vehicle-Loan Ineligible Page',
        tagId: 3552,
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'prequalify',
            level4: 'vehicle-loan',
            level5: 'exit',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.ICONIC_VEHICLE_AND_LOAN_CREDIT_DISPUTE_LINK]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Learn how to dispute it" link',
        tagId: 3553,
        featureName: 'Iconic Vehicle and Loan',
        tagName: 'credit dispute link',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.ICONIC_VEHICLE_AND_LOAN_VEHICLE_SHOWN]: {
        eventType: EventType.UI,
        tagDescription: 'Vehicle card is shown with Year Make and Model',
        tagId: 3554,
        featureName: 'Iconic Vehicle and Loan',
        tagName: 'vehicle shown',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.ICONIC_VEHICLE_AND_LOAN_LOAN_SHOWN]: {
        eventType: EventType.UI,
        tagDescription: 'Loan card is shown with Lender Name and loan terms',
        tagId: 3555,
        featureName: 'Iconic Vehicle and Loan',
        tagName: 'loan shown',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.ICONIC_VEHICLE_AND_LOAN_RETURN_TO_CAPITAL_ONE_BUTTON]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "return to capital one" button',
        tagId: 3556,
        featureName: 'Iconic Vehicle and Loan',
        tagName: 'return to capital one button',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.ICONIC_VEHICLE_AND_LOAN_CALCULATED_LTV]: {
        eventType: EventType.UI,
        tagDescription: 'System calculates ltv from loan balance divided by wholesale value',
        tagId: 3557,
        featureName: 'Iconic Vehicle and Loan',
        tagName: 'calculated ltv',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.ICONIC_VEHICLE_AND_LOAN_CHANGE_LOAN_LINK]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "I want to refinance a different loan" link',
        tagId: 3558,
        featureName: 'Iconic Vehicle and Loan',
        tagName: 'change loan link',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.ICONIC_VEHICLE_AND_LOAN_ELIGIBILITY_REQUIREMENTS_LINK]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Check our eligibility requirements" link',
        tagId: 3559,
        featureName: 'Iconic Vehicle and Loan',
        tagName: 'eligibility requirements link',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.ICONIC_VEHICLE_AND_LOAN_EDITED_FIELD]: {
        eventType: EventType.UI,
        tagDescription: 'User edits field on manual loan entry page',
        tagId: 3560,
        featureName: 'Iconic Vehicle and Loan',
        tagName: 'edited field',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}',
    },
    [TagKey.LOAN_LOOKUP_LOAN_FOUND_ELIGIBLE]: {
        eventType: EventType.UI,
        tagDescription: 'System finds an eligible TU loan following loan lookup',
        tagId: 3561,
        featureName: 'Loan Lookup',
        tagName: 'loan found eligible',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.MANUAL_LOAN_ENTRY_LEASE]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks radio button options for Is car under a lease agreement',
        tagId: 3562,
        featureName: 'Manual Loan Entry',
        tagName: 'lease',
        elementType: ElementType.RADIO,
        action: EventAction.CLICK,
        value: '${value}',
    },
};

export { PRODUCT_NAME, PRODUCT_VERSION, TAG_CATALOG, TagKey };
